import {DashboardTemplateConfig} from "../templates/templates-custom"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import ApiProject from "../../../../../core/gd/api/project"

// const debug = "createCustomDashboard"
const debug = false

export async function createCustomDashboard(template: DashboardTemplateConfig, creationParams: any = {}) {

    const params = {
        location    : _.get(creationParams, 'location', 'my-work'),
        ...creationParams
    }

    const settings = {
        appSettings : template.configFunction()
    }

    debug && console.log(debug, 'process', params)

    let response: any
    if (params.parentProjectId) {
        const parentProject = gd.session.projects.get(params.parentProjectId)!
        response = await ApiProject.newView({
            name            : template.dashboardTitle || template.name,
            color           : parentProject.color,
            parentProjectId : params.parentProjectId,
            projectIcon     : 'view-dashboard',
            settings        : {
                customView      : {
                    settings        : settings,
                    type            : ViewType.CUSTOM_VIEW_DASHBOARD
                }
            }
        }).promise()

        gd.navigation.goToProject(response.projectId)
    } else {
        response = await gd.api.Views.create(
            ViewType.CUSTOM_VIEW_DASHBOARD,
            template.dashboardTitle || template.name,
            params,
            0,
            null,
            settings
        ).promise()

        gd.navigation.goToDashboard(response.view.id)
    }


}